import officeRent from './office-rent';
import warehouseRent from './warehouse-rent';
import shoppingAreaRent from './shopping-area-rent';
import industryRent from './industry-rent';
import freeAppointmentObjectRent from './free-appointment-object-rent';
import officeSale from './office-sale';
import warehouseSale from './warehouse-sale';
import shoppingAreaSale from './shopping-area-sale';
import industrySale from './industry-sale';
import freeAppointmentObjectSale from './free-appointment-object-sale';

export default {
    officeRent,
    warehouseRent,
    shoppingAreaRent,
    industryRent,
    freeAppointmentObjectRent,
    officeSale,
    warehouseSale,
    shoppingAreaSale,
    industrySale,
    freeAppointmentObjectSale,
};
